import { writable } from "svelte/store";

const stateStore = writable({
  disableComponent: false,
  error: '',
});

export default stateStore;
